// Common Components
import { CheckBox, Button, Modal } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getHedgerDuedateTable } from "src/Requests/automaticMarketMaking";
// Types
import {
  IHedgerAccountDuedateTableReport,
  IIVOptionSearchParams,
} from "src/Interfaces/automaticMarketMaking";

interface IProps {
  searchParam: IIVOptionSearchParams;
}

const HedgerDuedateTable = ({ searchParam }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, sortingType, setSortingType, getExtraTypeUI }) => (
        <CommonTableUI
          reports={reports}
          tableBoxClassName="max-h-[500px]"
          sortingType={sortingType}
          setSortingType={setSortingType}
          getExtraTypeUI={getExtraTypeUI}
        />
      )}
      getDataTable={getHedgerDuedateTable}
      withSort
      searchParameters={searchParam}
      refreshTableTime={30000}
    />
  );
};

export default HedgerDuedateTable;
